import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  &,\n  & * {\n    cursor: ", ";\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    line-height: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  top: 0px;\n  z-index: 3;\n  right: 0px;\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    ", "\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  line-height: 26px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-right: 20px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  bottom: 17px;\n  color: rgb(204, 204, 204);\n  font-family: proxima-nova, sans-serif;\n  font-size: 13px;\n  font-weight: 200;\n  margin-top: 2px;\n  height: 23px;\n  line-height: 23px;\n  text-align: center;\n  top: 0px;\n  transform: matrix(1.5, 0, 0, 1, 0, 0);\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  margin: 0px 0px 16px 0px;\n\n  ", " {\n    margin: 0px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useRef, forwardRef } from 'react';
import styled, { useTheme } from 'styled-components';
import Icon from '../../icon';
import { faAngleUp, faAngleDown } from '../../icon/sets/solid';
import { legacySwappable, legacySwappableCss } from '../../theme';
import Dropdown, { useDropdownList, convertChildrenToItems } from '../../dropdown';
import BasicInput, { changeInputValueByRef, useOptionallyControlledInput, inputWidth } from '../../shared/input';
import { LegacyBoxContainer as LegacyBasicInputContainer } from '../../shared/input/components/BasicInput';
import useKeyboardSelect from '../utils/useKeyboardSelect';
import Measurable from '../../shared/input/components/Measurable';
import { ItemMargin } from '../../shared'; // Legacy theme

var LegacyContainer = styled.div(_templateObject(), LegacyBasicInputContainer);
var LegacyStyledInput = styled(BasicInput)(_templateObject2());
var LegacyRightIcon = styled.div.attrs({
  children: 'v'
})(_templateObject3());
var LegacyTriggerLabel = styled.div(_templateObject4());
var LegacyMeasurable = styled(Measurable)(_templateObject5(), function (_ref) {
  var theme = _ref.theme;
  return theme.fontCss('displaySmall');
}); // END legacy theme

var Container = legacySwappable(LegacyContainer, styled.div(_templateObject6(), inputWidth));
var StyledInput = legacySwappable(LegacyStyledInput, styled(BasicInput)(_templateObject7()));
var SelectDOMInput = styled.select(_templateObject8());
var HiddenInput = styled.input(_templateObject9(), legacySwappableCss('padding-right: 20px;', ''));
var TriggerLabel = legacySwappable(LegacyTriggerLabel, styled.div(_templateObject10()));
var Trigger = styled(forwardRef(function (_ref2, ref) {
  var selectedItem = _ref2.selectedItem,
      name = _ref2.name,
      className = _ref2.className,
      other = _objectWithoutProperties(_ref2, ["selectedItem", "name", "className"]);

  var theme = useTheme();
  var triggerRef = useRef();
  return /*#__PURE__*/React.createElement(React.Fragment, null, theme.name === 'legacy' &&
  /*#__PURE__*/
  // LEGACY theme
  React.createElement(LegacyMeasurable, {
    value: selectedItem && selectedItem.label || other.placeholder,
    targetRefs: [ref, triggerRef],
    extraOffset: 30
  }) // END LEGACY theme
  , /*#__PURE__*/React.createElement(TriggerLabel, {
    className: className,
    id: "".concat(name, "-value-label"),
    ref: triggerRef
  }, selectedItem && selectedItem.label || other.placeholder || /*#__PURE__*/React.createElement("span", null, "\xA0")), /*#__PURE__*/React.createElement(HiddenInput, _extends({}, other, {
    name: name,
    className: className
  }, {
    ref: ref,
    id: name,
    "aria-labelledby": "".concat(name, "-value-label ").concat(name, "-label")
  })));
})).attrs(function (props) {
  return _objectSpread(_objectSpread({}, props), {}, {
    readOnly: props.isFocused,
    role: 'button',
    tabIndex: 0,
    'aria-haspopup': 'listbox'
  });
})(_templateObject11(), function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});
var RightIcon = legacySwappable(LegacyRightIcon, function (_ref4) {
  var dropdownShown = _ref4.dropdownShown;
  return /*#__PURE__*/React.createElement(Icon, {
    icon: dropdownShown ? faAngleUp : faAngleDown
  });
});

var SelectInput = function SelectInput(_ref5) {
  var _ref5$children = _ref5.children,
      children = _ref5$children === void 0 ? [] : _ref5$children,
      _ref5$native = _ref5["native"],
      _native = _ref5$native === void 0 ? false : _ref5$native,
      className = _ref5.className,
      margin = _ref5.margin,
      width = _ref5.width,
      otherProps = _objectWithoutProperties(_ref5, ["children", "native", "className", "margin", "width"]);

  var theme = useTheme();
  var boxRef = useRef();
  var inputRef = useRef();
  var items = convertChildrenToItems(children);

  var _useOptionallyControl = useOptionallyControlledInput(otherProps),
      value = _useOptionallyControl.value,
      onChange = _useOptionallyControl.onChange;

  var selectedItem = items.find(function (item) {
    return item.value === value;
  });

  var _useDropdownList = useDropdownList({
    anchorRef: boxRef,
    items: items,
    onSelect: function onSelect(_ref6) {
      var optValue = _ref6.value;
      if (inputRef.current) inputRef.current.focus();
      changeInputValueByRef(inputRef, optValue);
    },
    value: otherProps.value
  }),
      baseOnKeyDown = _useDropdownList.onKeyDown,
      dropdownShown = _useDropdownList.dropdownShown,
      setDropdownShown = _useDropdownList.setDropdownShown,
      getItemProps = _useDropdownList.getItemProps,
      listProps = _useDropdownList.listProps,
      setSelected = _useDropdownList.setSelected;

  var onKeyDown = useKeyboardSelect({
    onKeyDown: baseOnKeyDown,
    items: items,
    setSelected: setSelected
  });
  var InputComponent = _native ? SelectDOMInput : Trigger;
  return /*#__PURE__*/React.createElement(ItemMargin, {
    margin: margin
  }, /*#__PURE__*/React.createElement(Container, {
    onKeyDown: onKeyDown,
    className: className,
    width: width
  }, /*#__PURE__*/React.createElement(StyledInput, _extends({}, otherProps, _native ? {
    children: [/*#__PURE__*/React.createElement("option", {
      value: ""
    })].concat(_toConsumableArray(React.Children.map(children, function (ch) {
      return React.cloneElement(ch, {
        "native": true
      });
    })))
  } : {
    onClick: function onClick() {
      return setDropdownShown(function (shown) {
        return !shown;
      });
    }
  }, {
    onChange: onChange,
    value: value,
    selectedItem: selectedItem
  }, {
    inputRef: inputRef,
    ref: boxRef,
    inputComponent: InputComponent,
    rightIcon: /*#__PURE__*/React.createElement(RightIcon, {
      dropdownShown: dropdownShown
    }),
    margin: "none"
  })), dropdownShown && /*#__PURE__*/React.createElement(Dropdown, _extends({
    getItemProps: getItemProps,
    listProps: listProps
  }, {
    name: otherProps.name,
    anchorRef: theme.name === 'legacy' ? inputRef : boxRef
  }), children)));
};

export default SelectInput;